const authActions = {
    AUTH_LOGIN: 'AUTH_LOGIN',
    BACKOFFICE_FORGET_PASSWORD:'BACKOFFICE_FORGET_PASSWORD',
    BACKOFFICE_TOKEN_VERIFY: 'BACKOFFICE_TOKEN_VERIFY',
    SET_BACKOFFICE_TOKEN_DETAILS: 'SET_BACKOFFICE_TOKEN_DETAILS',
    ROLE_TOKEN_GENERATION: 'ROLE_TOKEN_GENERATION',
};

export default authActions;